import { Link } from "react-router-dom";
import { theme } from "../theme";
import { num } from "../utils";
import ShopSetupNotice from "./ShopSetupNotice";

const MAX_RADKU = 5;

// ── Vyžaduje pozornost ────────────────────────────────────────────────────────
// Jeden seznam místo tří sekcí: na řádku je vše, co o produktu víme — kam
// klesl a o kolik snížit cenu. Řadí se podle naléhavosti, největší propad
// nahoře, pak nejsnazší předběhnutí.
const Hlavicka = () => (
  <div style={{ display: "flex", alignItems: "center", gap: 11, padding: "20px 22px 6px", flexWrap: "wrap" }}>
    <span style={{
      width: 32, height: 32, borderRadius: theme.rTile, flexShrink: 0,
      background: theme.blueSoft, color: theme.blue,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg>
    </span>
    <span style={{ fontSize: 17, fontWeight: 800, color: theme.ink, flex: 1, letterSpacing: "-0.3px" }}>Vyžaduje pozornost</span>
    <Link to="/produkty" style={{
      border: `1px solid ${theme.line}`, borderRadius: theme.rBtn, padding: "8px 16px",
      color: theme.inkSoft, fontSize: 13, fontWeight: 600, textDecoration: "none", whiteSpace: "nowrap",
    }}>Zobrazit všechny</Link>
  </div>
);

export default function NeedsAttention({ products, onOpen, shopMissing = false }) {
  // Bez shop_id je pozice u všech produktů prázdná, takže by tahle sekce
  // spadla do zeleného "vše v pořádku" — a to je přesně opak pravdy.
  if (shopMissing) {
    return (
      <ShopSetupNotice title="Nevíme, které nabídky jsou vaše">
        Dokud nemáte nastavený e-shop, Rankio nepozná vaši nabídku na Heurece a pozice se neměří.
      </ShopSetupNotice>
    );
  }

  const radky = products
    .filter(p => p.position)
    .map(p => {
      const klesl = p.previous_position && p.position > p.previous_position;
      const doporucena = (p.our_total_price && p.above_total_price) ? p.above_total_price - 1 : null;
      const uspora = doporucena !== null ? p.our_total_price - doporucena : null;
      return {
        ...p,
        _propad: klesl ? p.position - p.previous_position : 0,
        _uspora: (p.position !== 1 && uspora !== null && uspora > 0) ? uspora : null,
      };
    })
    .filter(p => p._propad > 0 || p._uspora !== null)
    .sort((a, b) => b._propad - a._propad || a._uspora - b._uspora)
    .slice(0, MAX_RADKU);

  const vitezove = products.filter(p => p.position === 1);

  if (radky.length === 0) {
    return (
      <div className="fadeUp" style={{
        background: theme.bg, border: `1.5px solid ${theme.line}`, borderRadius: theme.rCard,
        boxShadow: theme.shadowSm, marginBottom: 20,
      }}>
        <Hlavicka />
        <div style={{ padding: "8px 14px 16px" }}>
          <div style={{
            display: "flex", alignItems: "center", gap: 14,
            background: theme.okSoft, border: `1px solid ${theme.okLine}`,
            borderRadius: theme.rCard, padding: "16px 18px",
          }}>
            <div style={{ width: 36, height: 36, borderRadius: theme.rTile, background: theme.bg, border: `1px solid ${theme.okLine}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke={theme.ok} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            </div>
            <div>
              <p style={{ fontWeight: 700, fontSize: 14.5, color: "#166534", marginBottom: 2 }}>Vše vypadá dobře</p>
              <p style={{ fontSize: 13, color: "#15803d" }}>
                Žádný produkt teď nevyžaduje vaši pozornost
                {vitezove.length > 0 && <> a na 1. místě držíte <strong style={{ fontVariantNumeric: theme.tnum }}>{vitezove.length}</strong> {vitezove.length === 1 ? "produkt" : vitezove.length < 5 ? "produkty" : "produktů"}</>}.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fadeUp" style={{
      background: theme.bg, border: `1.5px solid ${theme.line}`, borderRadius: theme.rCard,
      boxShadow: theme.shadowSm, marginBottom: 20,
    }}>
      <Hlavicka />

      <div style={{ padding: "8px 14px 16px" }}>
        {radky.map(p => (
          <div key={p.id} style={{
            display: "flex", alignItems: "center", gap: 14,
            padding: "12px 8px", borderRadius: theme.rCard, flexWrap: "wrap",
          }}
            onMouseEnter={e => { e.currentTarget.style.background = theme.bgSoft; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
            <span style={{
              minWidth: 46, padding: "6px 10px", borderRadius: theme.rTile, flexShrink: 0,
              background: p._propad > 0 ? theme.badSoft : theme.blueSoft,
              color: p._propad > 0 ? theme.bad : theme.blue,
              fontSize: 13.5, fontWeight: 700, textAlign: "center", fontVariantNumeric: theme.tnum,
            }}>#{p.position}</span>

            <div style={{ minWidth: 160, flex: 1 }}>
              <p style={{ fontSize: 14, fontWeight: 600, color: theme.ink, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.name}</p>
              {p.group_name && <p style={{ fontSize: 11.5, color: theme.mut, marginTop: 2 }}>{p.group_name}</p>}
            </div>

            <div style={{ minWidth: 200, flex: 1.2 }}>
              {p._propad > 0 && (
                <p style={{ fontSize: 13, color: theme.ink }}>
                  Klesl z <span style={{ fontVariantNumeric: theme.tnum }}>#{p.previous_position}</span> na <span style={{ fontVariantNumeric: theme.tnum }}>#{p.position}</span>
                </p>
              )}
              {p._uspora !== null && (
                <p style={{ fontSize: 13, color: theme.blueDark, marginTop: p._propad > 0 ? 2 : 0 }}>
                  Snižte o <strong style={{ fontVariantNumeric: theme.tnum }}>{num(p._uspora)} Kč</strong> a předběhnete {p.above_shop_name}
                </p>
              )}
            </div>

            <button onClick={() => onOpen(p)} style={{
              background: theme.blue, border: "none", borderRadius: theme.rBtn,
              padding: "9px 16px", color: "#fff", fontSize: 13, fontWeight: 700,
              cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap", flexShrink: 0,
            }}>Zobrazit detail →</button>
          </div>
        ))}
      </div>

      {vitezove.length > 0 && (
        <div style={{
          borderTop: `1px solid ${theme.line}`, padding: "12px 22px",
          display: "flex", alignItems: "center", gap: 9, flexWrap: "wrap",
        }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={theme.ok} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6M18 9h1.5a2.5 2.5 0 0 0 0-5H18M4 22h16M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22M18 2H6v7a6 6 0 0 0 12 0V2Z"/></svg>
          <span style={{ fontSize: 13, color: theme.inkSoft }}>
            Na 1. místě držíte <strong style={{ color: theme.ok, fontVariantNumeric: theme.tnum }}>{vitezove.length}</strong> {vitezove.length === 1 ? "produkt" : vitezove.length < 5 ? "produkty" : "produktů"}.
          </span>
        </div>
      )}
    </div>
  );
}
